import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import { SessionExpiredComponent } from '@shared/components/session-expired/session-expired.component';
import { E500Component, E404Component, E401Component, FinishPageComponent } from '@shared/components';
import {PendingChangesGuard} from '@modules/cases/containers/case-item-overview/pending-changes.guard';



const routes: Routes = [
  {path: '', loadChildren: () => import('./modules/cases/').then(m => m.CasesModule), canDeactivate: [PendingChangesGuard]},
  {path: 'sessionExpired', component: SessionExpiredComponent, pathMatch: 'full'},
  {path: 'finish', component: FinishPageComponent },
  {path: 'e500', component: E500Component},
  {path: 'e404', component: E404Component},
  {path: 'e401', component: E401Component},
  {path: '**', component: E404Component},
];


@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule {

}
